import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import ActionGenerator from './Components/ActionGenerator';
import PrintStyles from '../../Styles/Print.scss'; // eslint-disable-line no-unused-vars

function ActionPrint({ children, status, onClick }) {
    return (<ActionGenerator status={status} onClick={onClick} icon="print" type="print">
        {children}
    </ActionGenerator>)
}

ActionPrint.propTypes = {
    status: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.any,
};

ActionPrint.defaultProps = {
    children: null,
};

ActionPrint.displayName = displayName('Buttons/ActionButtons/ActionPrint');

export default ActionPrint;
